import FeatureSectionOne, { FeatureSectionOneProps } from './FeatureSectionOne'

export default FeatureSectionOne

export { FeatureSectionOne }
export type { FeatureSectionOneProps }
